import { DEFAULT_OPTIONS } from '../constants';

export const SHOW_TOAST = {
  default: 'SHOW_TOAST_DEFAULT',
};

export const showToastDefault = (message, options = DEFAULT_OPTIONS) => ({
  type: SHOW_TOAST.default,
  message,
  options,
});
